module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.formrules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "目标通知到"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.member_total || 0))]), _vm._v(" "), _c('span', [_vm._v("人")])]), _vm._v(" "), (!_vm.role.single) ? _c('el-form-item', {
    attrs: {
      "label": "适用门店",
      "prop": "sub_mchnt_list"
    }
  }, [_c('el-select', {
    ref: "selectShops",
    attrs: {
      "placeholder": "请选择门店",
      "multiple": "",
      "size": "small"
    },
    model: {
      value: (_vm.form.sub_mchnt_list),
      callback: function($$v) {
        _vm.$set(_vm.form, "sub_mchnt_list", $$v)
      },
      expression: "form.sub_mchnt_list"
    }
  }, _vm._l((_vm.shopList), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单个红包金额"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "singleValue"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.form.singleValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "singleValue", _vm._n($$v))
      },
      expression: "form.singleValue"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("元")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用条件"
    }
  }, [_c('span', [_vm._v("微信支付")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "limit_amt"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.form.limit_amt),
      callback: function($$v) {
        _vm.$set(_vm.form, "limit_amt", _vm._n($$v))
      },
      expression: "form.limit_amt"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("元以上可用")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('span', [_vm._v("领取后")]), _vm._v(" "), _c('span', [_vm._v("14")]), _vm._v(" "), _c('span', [_vm._v("天内可使用")]), _vm._v(" "), _c('div', {
    staticClass: "remark"
  }, [_c('p', [_vm._v("注：")]), _vm._v(" "), _c('p', [_vm._v("1、确认提交后，将在次日以公众号的形式将你的店铺红包发给会员；")]), _vm._v(" "), _c('p', [_vm._v("2、红包费用由商户承担；")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ade8b0b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/packetnotify/packetnotify.vue
// module id = 813
// module chunks = 1